import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.element.dataset.productPageReady = "true"
    this.scrollHandler = () => this.scrollToTop()
    window.addEventListener("pageshow", this.scrollHandler)
    document.addEventListener("turbo:load", this.scrollHandler)
    if (document.readyState !== "complete") window.addEventListener("load", this.scrollHandler, { once: true })

    this.scrollToTop()
    this.firstFrame = requestAnimationFrame(() => {
      this.secondFrame = requestAnimationFrame(() => this.scrollToTop())
    })
  }

  disconnect() {
    window.removeEventListener("pageshow", this.scrollHandler)
    window.removeEventListener("load", this.scrollHandler)
    document.removeEventListener("turbo:load", this.scrollHandler)
    if (this.firstFrame) cancelAnimationFrame(this.firstFrame)
    if (this.secondFrame) cancelAnimationFrame(this.secondFrame)
    delete this.element.dataset.productPageReady
    delete this.element.dataset.productPageScrollTop
  }

  scrollToTop() {
    window.scrollTo(0, 0)
    this.element.dataset.productPageScrollTop = String(window.scrollY)
  }
}
